<template>
  <div class="aboutUs">
    <section class="section-container">
      <div class="text desc">
        <h3 class="heading">{{ $t('pageAboutus.heading') }}</h3>
        <p class="cite">«{{ $t('pageAboutus.cite.p1') }}»</p>
        <p>{{ $t('pageAboutus.cite.p2') }}</p>
        <p>{{ $t('pageAboutus.cite.p3') }}</p>
        <p>{{ $t('pageAboutus.cite.p4') }}</p>
      </div>
      <img
        class="text-img"
        src="https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627403292/Aboutus/rizes_about_5_qca54x.jpg"
        alt="rizes house"
      />
    </section>
    <section class="section-container">
      <div class="info-images">
        <div class="big"></div>
        <div class="small1"></div>
        <div class="small2"></div>
        <div class="small3"></div>
      </div>
      <div class="text info">
        <h3 class="heading">{{ $t('pageAboutus.info.heading') }}</h3>
        <ul>
          <li>{{ $t('pageAboutus.info.l1') }}</li>
          <li>{{ $t('pageAboutus.info.l2') }}</li>
          <hr />
          <li>{{ $t('pageAboutus.info.l3') }}</li>
          <hr />
          <li>{{ $t('pageAboutus.info.l4') }}</li>

          <hr />
          <li>{{ $t('pageAboutus.info.l5') }}</li>

          <hr />
          <li>{{ $t('pageAboutus.info.l6') }}</li>
          <hr />
          <li>{{ $t('pageAboutus.info.l7') }}</li>
          <hr />
          <li>{{ $t('pageAboutus.info.l8') }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.aboutUs {
  background-color: hsl(var(--clr-primary-700));
  border: 0;
  border-top: 1px solid hsl(var(--clr-grey-500) / 0.1);
  margin: 8px 0;
}

.section-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 45px 0;
  // background-color: var(--primary);
}

.cite {
  color: hsl(var(--clr-accent-500));
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  font-style: italic;
}

.desc {
  max-width: 668px;
}

.info {
  max-width: 450px;
}

.text {
  padding: 34px 50px;
  background-color: hsl(var(--clr-primary-500));
  color: hsl(var(--clr-primary-100));
  margin: 0 1%;

  li {
    font-size: 16px;
    line-height: 20px;
    padding: 12px;
  }

  .text-img {
    max-height: 560px;
    width: auto;
  }
}

.heading {
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 400;
  text-transform: uppercase;
}

p {
  margin-bottom: 16px;
  line-height: 1.5;
}

.info-images {
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 10px 10px;
  grid-template-areas:
    'big small1'
    'big small2'
    'big small3';
  width: 40%;
  height: 550px;
}
.big {
  grid-area: big;
  min-width: 288px;
  height: auto;
  background-image: url('https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1627403292/Aboutus/rizes_about_4_r9nka0.jpg');
  background-size: cover;
  background-position: center;
}
.small1 {
  grid-area: small1;
  max-height: 175px;
  width: auto;
  background-image: url('https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1627405846/Aboutus/rizes_about_1_p84j6q.jpg');
  background-size: cover;
  background-position: center;
}
.small2 {
  grid-area: small2;
  max-height: 175px;
  width: auto;
  background-image: url('https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1627406137/Aboutus/rizes_about_3_xd9nts.jpg');
  background-position: center;
  background-size: cover;
}
.small3 {
  grid-area: small3;
  max-height: 175px;
  width: auto;
  background-image: url('https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_300/v1627406034/Aboutus/rizes_about_2_kuneo1.jpg');
  background-size: fill;
  background-position: center;
}

// .info-img {
//   object-fit: cover;
// }

@media (max-width: 900px) {
  .aboutUs {
    .section-container {
      flex-direction: column;
      padding: 0;

      .desc,
      .info {
        max-width: 85%;
      }

      .info-images {
        width: 95%;
      }
    }
  }
}

@media (max-width: 400px) {
  .aboutUs {
    .section-container {
      padding: 10px 0;

      .heading {
        font-size: 18px;
      }

      .cite {
        font-size: 16px;
        line-height: 18px;
      }

      .desc,
      .info {
        max-width: 100%;

        p {
          font-size: 16px;
          line-height: 20px;
        }
      }

      .text {
        padding: 34px 20px;
      }
      .big {
        min-width: 179px;
      }
    }
  }
}
</style>
